import { ActionContext } from "vuex";
import { CrudState } from "@/store/crud/State";
import { ICrudOptions } from "@/interfaces/ICrudOptions";
import CrudActions from "@/store/crud/classes/CrudActions";
import CrudResetActions from "@/store/crud/classes/CrudResetActions";
import CrudService from "@/services/CrudService";

export const crudActions: CrudActions = new CrudActions();
export const crudResetActions: CrudResetActions = new CrudResetActions();

export async function findOne(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): Promise<any> {
  return crudActions.findOne(store, options);
}

export async function findAll(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): Promise<any> {
  return crudActions.findAll(store, options);
}

export async function findAllSubresource(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): Promise<any> {
  return crudActions.findAllSubresource(store, options);
}

export async function create(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): Promise<any> {
  return crudActions.create(store, options);
}

export async function upload(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): Promise<any> {
  return crudActions.upload(store, options);
}

export async function update(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): Promise<any> {
  return crudActions.update(store, options);
}

export async function patch(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): Promise<any> {
  return crudActions.patch(store, options);
}

export async function del(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): Promise<any> {
  return crudActions.delete(store, options);
}

export function resetAll(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): void {
  crudResetActions.resetAll(store, options);
}

export function resetDelete(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): void {
  crudResetActions.resetDelete(store, options);
}

export function resetList(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): void {
  crudResetActions.resetList(store, options);
}

export function resetSave(
  store: ActionContext<CrudState, any>,
  options: ICrudOptions
): void {
  crudResetActions.resetSave(store, options);
}

export function setError(store: ActionContext<any, any>, error: any): void {
  store.commit("SET_ERROR", error);
}

export function setIsLoading(
  store: ActionContext<any, any>,
  loading: boolean
): void {
  store.commit("IS_LOADING", loading);
}

export function setDataList(
  store: ActionContext<any, any>,
  dataList: Array<any>
): void {
  store.commit("SET_DATA_LIST", dataList);
}

export function setDataItem(store: ActionContext<any, any>, item: any): void {
  store.commit("SET_DATA_ITEM", item);
}
